/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2493
 */

var r = require(/* 502 */"../../../../../../../../../2588/1461/2585/502/index")["__core-js_shared__"]
module.exports = r
